import api from '../configs/api.config';
import { downloadBlob } from '../helpers/utils';
import {
  ReportBuilderRequest,
  ReportFieldMetadata,
  ReportPreview,
  ReportEntityType,
  entityTypeToNumber
} from '../types/report.types';

export const getReportFields = async (
  entityType: ReportEntityType
): Promise<ReportFieldMetadata[]> => {
  const entityTypeNum = entityTypeToNumber(entityType);
  const { data } = await api.get<ReportFieldMetadata[]>(`/Report/fields/${entityTypeNum}`);
  return data;
};

export const generateReport = async (request: ReportBuilderRequest): Promise<void> => {
  const response = await api.post('/Report/generate', request, {
    responseType: 'blob'
  });

  // Extract the filename from Content-Disposition header
  const contentDisposition = response.headers['content-disposition'];
  const match = contentDisposition?.match(/filename="?([^"]+)"?/);
  const entityTypeName = request.entityType === 0 ? 'Client' : 'Plate';
  const fileName = match ? match[1] : `${entityTypeName}Report.csv`;

  downloadBlob(response.data, fileName);
};

export const previewReport = async (request: ReportBuilderRequest): Promise<ReportPreview> => {
  const { data } = await api.post<ReportPreview>('/Report/preview', request);
  return data;
};
